<template>
    <div class="flex-1 flex"
        :class="broker_will_sign ? '' : 'opacity-40'"
    >
        <div class="w-24 text-blue-600 font-semibold pt-px">
            Broker
        </div>

        <div class="flex-1 flex flex-col sm:flex-row pl-4">
            <div class="sm:col-gap-2 sm:w-2/5">
                <input-text
                    :value="property.broker.name"
                    label="Name"
                    :read_only="true"
                />
            </div>

            <div class="sm:col-gap-2 sm:w-3/5">
                <input-text
                    :value="property.broker.email"
                    label="Email"
                    :read_only="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        property: {},
        envelope: {},
        broker_will_sign: {},
    },
}
</script>
